import { User, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { motion } from "framer-motion";
import { BRAND } from "@/styles/brand";

// ═══════════════════════════════════════════════════════════════════════════
// PROFILE BUTTON - Subtiles, elegantes Design
// ═══════════════════════════════════════════════════════════════════════════
export default function ProfileButton() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => navigate("/profile")}
      className="fixed top-4 right-4 z-40 w-11 h-11 rounded-full flex items-center justify-center transition-all"
      style={{ 
        backgroundColor: BRAND.colors.bgCard,
        boxShadow: BRAND.shadows.md,
        border: `1.5px solid ${BRAND.colors.border}`,
      }}
      data-testid="profile-button"
    >
      {user ? (
        <span 
          className="text-base font-semibold"
          style={{ 
            color: BRAND.colors.primary,
            fontFamily: BRAND.typography.body,
          }}
        >
          {user.name ? user.name.charAt(0).toUpperCase() : <User size={20} style={{ color: BRAND.colors.primary }} />}
        </span>
      ) : (
        <User size={20} style={{ color: BRAND.colors.textSecondary }} />
      )}
    </motion.button>
  );
}
